var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter fa-xs",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.userType')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userrole),
      expression: "userrole"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "userrole"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.userrole = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.userType')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "b2b_picker"
    }
  }, [_vm._v(_vm._s(_vm.$t('userProperties.b2bPicker')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "b2b_packer"
    }
  }, [_vm._v(_vm._s(_vm.$t('userProperties.b2bPacker')))])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('userProperties.userProperty')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userproperty),
      expression: "userproperty"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "userproperty"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.userproperty = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('userProperties.selectUserProperty')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "b2bPieceLevelPicking"
    }
  }, [_vm._v(_vm._s(_vm.$t('userProperties.pieceLevelPickingEnabled')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "b2bPieceLevelPacking"
    }
  }, [_vm._v(_vm._s(_vm.$t('userProperties.pieceLevelPackingEnabled')))])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('userList.userEmail')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selecteduser),
      expression: "selecteduser"
    }],
    staticStyle: {
      "height": "32px",
      "min-height": "32px"
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('userProperties.userEmailPlaceHolder')
    },
    domProps: {
      "value": (_vm.selecteduser)
    },
    on: {
      "change": function($event) {
        _vm.useremailcheck()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selecteduser = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "30px",
      "margin-right": "60px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getUserDataSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('inwardList.search')))]), _vm._v(" \n                  "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("  " + _vm._s(_vm.$t('inwardList.reset')))])])])])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-4 s1 cardlistheader"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('userList.useList')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 s0 cardlistheader"
  }), _vm._v(" "), (_vm.totalRows > 0) ? _c('div', {
    staticClass: "col-md-2 s1 o3 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('product.table.count')) + " - " + _vm._s(_vm.totalRows))])]) : _vm._e()]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('loginUsers.UserId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('userList.userEmail')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('client.action')))])])])]), _vm._v(" "), _c('tbody', [(_vm.resultCount == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "5",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('pincodemapping.noRecordFound')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listUserData), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_c('strong', [_vm._v(_vm._s(data.userid))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.email))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-edit text-successedit fa-lg mt-2",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.getUserRowData(data)
        }
      }
    })])])
  })], 2)])]), _c('br'), _vm._v(" "), (_vm.totalPage && _vm.listUserData.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('b-modal', {
    staticClass: "centered-modal",
    attrs: {
      "size": "vlg",
      "no-close-on-backdrop": true
    },
    on: {
      "ok": function($event) {
        _vm.showfeaturepermission = false
      }
    },
    model: {
      value: (_vm.showfeaturepermission),
      callback: function($$v) {
        _vm.showfeaturepermission = $$v
      },
      expression: "showfeaturepermission"
    }
  }, [(_vm.showfeaturepermission) ? _c('div', {
    staticClass: "popup-container",
    attrs: {
      "id": "popup"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closePopup
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.userPersonname))]), _c('br'), _vm._v(" "), _vm._l((_vm.permissions), function(permission, index) {
    return _c('div', {
      key: index,
      staticClass: "toggle-container"
    }, [_c('span', {
      staticClass: "toggle-label"
    }, [_vm._v(_vm._s(permission.key))]), _vm._v(" "), _c('label', {
      staticClass: "toggle-switch"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission.value),
        expression: "permission.value"
      }],
      attrs: {
        "type": "checkbox",
        "id": 'toggle-permission-' + (index + 1)
      },
      domProps: {
        "checked": Array.isArray(permission.value) ? _vm._i(permission.value, null) > -1 : (permission.value)
      },
      on: {
        "__c": function($event) {
          var $$a = permission.value,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (permission.value = $$a.concat($$v))
            } else {
              $$i > -1 && (permission.value = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            permission.value = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "toggle-slider"
    })])])
  }), _vm._v(" "), _c('button', {
    attrs: {
      "id": "save-permissions-btn"
    },
    on: {
      "click": _vm.changeUserStatus
    }
  }, [_vm._v(_vm._s(_vm.$t('common.saveBtn')))])], 2) : _vm._e()])], 1)])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1e45ec1d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e45ec1d","hasScoped":true}!./src/views/components/userproperties/userproperties.component.html
// module id = 2108
// module chunks = 0